import {getCheckoutClient} from '../../../config/CheckoutClient';
import { addServerErrors } from '../../../actions/ui';
import { getMemberPayload } from 'checkout/selectors/request';

export function setName(name) {
    return {type: "SET_MEMBER_NAME", name};
}

export function setEmail(email) {
    return {type: "SET_MEMBER_EMAIL", email};
}

export function setPhone(phone) {
    return {type: "SET_MEMBER_PHONE", phone};
}

export function setAddress(address) {
    return {type: "SET_MEMBER_ADDRESS", address};
}

export function setSaved(value) {
    return {type: "SET_MEMBER_SAVED", value};
}

export function setEmailOptOut(value) {
    return {type: "SET_MEMBER_EMAIL_OPT_OUT", value};
}

//modify initial state to change the default value
export function setDefaultEmailOptOut(value) {
    return {type: "SET_DEFAULT_MEMBER_EMAIL_OPT_OUT", value};
}

export function setCreatedNewAccount(value) {
    return {type: "SET_MEMBER_CREATED_NEW_ACCOUNT", value};
}

export function submitMemberInfo() {
    return (dispatch, getState) => {
        let state = getState();
        let payload = getMemberPayload(state);

        return getCheckoutClient(state.ui.apiUrl).reservationCreateRequest(state.reservation.token, 'customer', payload, state.reservation.secret).then((result) => {
            dispatch(setSaved(true));
        }).catch((error) => {
            if (error.response.statusCode === 400) {
                dispatch(addServerErrors(error.response.body.errors));
                return Promise.reject("");
            }
        });
    }
}
